import type { DataCollection } from '@sentry/core';

/**
 * Headers worth keeping on a report: they tell browsers and payload shapes apart
 * without identifying anyone. Sentry matches these case-insensitively and replaces
 * every other header's value with "[Filtered]".
 */
const SAFE_HEADERS = ['user-agent', 'content-type', 'content-length'];

/**
 * What Sentry may collect, in the browser and on the server. Its defaults send
 * request and response bodies, cookies, query strings, user details and local
 * variable values. Estimates hold customer, vehicle and claim data, and a service
 * outside the stamp's country may only receive scrubbed data (D-003), so everything
 * that can carry tenant data is off: a report holds code locations, IDs and codes.
 */
export function minimalDataCollection(): DataCollection {
  return {
    userInfo: false,
    cookies: false,
    httpHeaders: { request: { allow: [...SAFE_HEADERS] }, response: { allow: [...SAFE_HEADERS] } },
    httpBodies: [],
    urlQueryParams: false,
    graphQL: { document: false, variables: false },
    genAI: { inputs: false, outputs: false },
    databaseQueryData: false,
    queues: false,
    stackFrameVariables: false,
  };
}
